// extracted by mini-css-extract-plugin
export var cover = "header-live-search-styles-dr-module--cover--f8961";
export var dark = "header-live-search-styles-dr-module--dark--59393";
export var headerLiveSearch = "header-live-search-styles-dr-module--header-live-search--1e6e7";
export var imageWrapper = "header-live-search-styles-dr-module--image-wrapper--bcc84";
export var inner = "header-live-search-styles-dr-module--inner--6aad2";
export var innerWithImage = "header-live-search-styles-dr-module--inner-with-image--dc161";
export var keyDown = "header-live-search-styles-dr-module--key-down--46f9c";
export var light = "header-live-search-styles-dr-module--light--d6c36";
export var liveSearch = "header-live-search-styles-dr-module--live-search--7b34d";
export var liveSearchInput = "header-live-search-styles-dr-module--live-search-input--b8409";
export var liveSearchResult = "header-live-search-styles-dr-module--live-search-result--d06b5";
export var medium = "header-live-search-styles-dr-module--medium--a77a2";
export var slope = "header-live-search-styles-dr-module--slope--d46d3";
export var slopeWrapper = "header-live-search-styles-dr-module--slope-wrapper--09cbe";